import { UUID } from '@/types/types';
import { ProjectRenderer } from '../ProjectRenderer';
import { RenderUtils } from '../RenderUtils';
import {
	Box3,
	Box3Helper,
	MeshStandardMaterial,
	Object3D,
	Vector3,
} from 'three';
import { SiphonsManager } from '../SiphonsManager';

export class Siphon {
	id: UUID;
	object: Object3D;
	private _isColiding = false;
	private _posX = 0;
	private boxHelper!: Box3Helper;
	private materials: MeshStandardMaterial[] = [];
	box = new Box3();

	constructor(private renderer: ProjectRenderer, id: UUID, object: Object3D) {
		this.renderer = renderer;

		this.id = id;

		object.visible = true;
		this.object = object;

		this.object.traverse((child) => {
			if (!RenderUtils.isMesh(child)) return;
			this.materials.push(child.material as MeshStandardMaterial);
		});

		for (const material of this.materials) {
			material.emissive.set(0xff0000);
			material.emissiveIntensity = 0;
		}

		this.setBox();
		this.boxHelper = new Box3Helper(this.box, 0xff0000);

		if (import.meta.env.DEV) this.renderer.scene.add(this.boxHelper);

		this.renderer.product.add(this.object);
	}

	get isColiding() {
		return this._isColiding;
	}

	set isColiding(value: boolean) {
		this._isColiding = value;
		for (const material of this.materials) {
			material.emissiveIntensity = value ? 1 : 0;
		}
	}

	get posX() {
		return this._posX;
	}

	set posX(value: number) {
		this._posX = value;
		this.updateWorldPosition();
	}

	private setBox() {
		this.box.setFromObject(this.object, true);
		this.box.expandByVector(new Vector3(SiphonsManager.SIPHONS_MIN_GAP, 0, 0));
	}

	updateWorldPosition() {
		const { xStart } =
			this.renderer.productBuilder.getAvailableSiphonsAxisData();
		this.object.position.x = xStart + this._posX;
		this.setBox();
	}

	dispose() {
		RenderUtils.disposeObject(this.object);
		this.boxHelper.removeFromParent();
		this.boxHelper.dispose();
		this.object.removeFromParent();
	}
}
